import React from 'react';
import { Provider } from 'react-redux';
import { getStore } from './store/store';
import { ThemeProvider } from './context/ThemeContext';
import './global.scss';
import { Maintenance } from './module/client/layout/maintenance/maintenance';

const MAINTENANCE_MESSAGE = `
  <strong><u>Scheduled System Upgrade<br/> July 17-20</u></strong><br/><br/>
  We're completing the final stage of this system upgrade to improve our service. The portal is expected to be available by 1pm PT/4pm ET, after which all normal processing will resume.
  <br/><br/>
  <strong>Urgent supplies:</strong> <a href="mailto:orders@flextg.com">orders@flextg.com</a> | <strong>Service:</strong> <a href="mailto:service@flextg.com">service@flextg.com</a>
`;

function App() {
  const store = getStore();
  return (
    <Provider store={store}>
      <ThemeProvider>
        <Maintenance message={MAINTENANCE_MESSAGE} />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
